module.exports = __webpack_public_path__ + "static/media/noPricing.b9fbf0f2.svg";